<template>
  <button type="button" class="back-btn" @click="handleClick">
    <i class="fas fa-arrow-left"></i>
  </button>
</template>

<script>
export default {
  name: 'BaseBackButton',
  emits: ['click'],
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    }
  }
};
</script>

<style scoped>
.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #E2E8F0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  color: #64748B;
}

.back-btn:hover {
  background: #F8FAFC;
  border-color: #0D9488;
  color: #0D9488;
}

.back-btn i {
  font-size: 14px;
}
</style>
